import { render } from "./SettingSidebar.vue?vue&type=template&id=12ba6d92"
import script from "./SettingSidebar.vue?vue&type=script&lang=js"
export * from "./SettingSidebar.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__